module.exports = __webpack_public_path__ + "img/pcbm.1ed57e75.jpg";